import { stripHtml } from './caretUtils';

export const isBlockEmpty = (block) => stripHtml(block.content).trim() === '';

export const parentOf = (blockList, id, parent = null) => {
  for (const b of blockList) {
    if (b.id === id) return parent;
    if (b.children?.length) {
      const found = parentOf(b.children, id, b);
      if (found !== null) return found;
    }
  }
  return null;
};
